import { useEffect } from "react";
import { useGetPlansQuery } from "../../features/api/plansApiSlice";
import PdfCard from "./PdfCard";
import "./PdfGridPage.scss";
import LoadingSpinner from "../loader/Loader";

const PdfGridPage = () => {
  const {
    data: plans = [], // ✅ safe default so maps never blow up
    isFetching, // use this for spinner
    isError,
    isLoading,
    refetch,
  } = useGetPlansQuery(undefined, {
    refetchOnMountOrArgChange: "always", // ✅ refetch every time page mounts
    refetchOnFocus: true, // refresh when tab regains focus
    refetchOnReconnect: true, // refresh when network comes back
  });

  useEffect(() => {
    if (!plans?.length && !isFetching && !isError) {
      refetch(); // one more nudge in case the first request was aborted in dev
    }
  }, [plans?.length, isFetching, isError, refetch]);

  if (isLoading) return <LoadingSpinner />;

  return (
    <div className="main_wrapper">
      <div className="page-container">
        <div className="top-page-flex">
          <h2>Enotes Unlimited Plans</h2>
        </div>
        <div className="pdf-grid-container">
          {plans.map((pdf, index) => (
            <PdfCard key={index} url={pdf.pdfUrls[0]} title={pdf.title} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PdfGridPage;

// import PdfCard from "./PdfCard";
// import "./PdfGridPage.scss"; // Create this CSS file for styling

// const pdfs = [
//   {
//     url: "https://woodsmithstorecontent.s3.us-east-2.amazonaws.com/resources/a2116a72-7574-4f82-bb66-950b8ed86c2d.pdf",
//     title: "Woodsmith Store PDF 1",
//   },
//   {
//     url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
//     title: "W3C Dummy PDF",
//   },
//   // Add more PDF objects here
// ];

// const PdfGridPage = () => {
//   return (
//     <div className="pdf-grid-container">
//       {pdfs.map((pdf, index) => (
//         <PdfCard key={index} url={pdf.url} title={pdf.title} />
//       ))}
//     </div>
//   );
// };

// export default PdfGridPage;
